import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M533.333,586.667 L533.333,693.333 L213.333,693.333 L213.333,1173.33 L213.755,1173.33 L447.355,1386.67 L1472.64,1386.67 L1706.24,1173.33 L1706.67,1173.33 L1706.67,693.333 L1386.67,693.333 L1386.67,586.667 L1738.67,586.667 C1779.9,586.667 1813.33,620.096 1813.33,661.333 L1813.33,661.333 L1813.33,1173.33 L1856,1173.33 C1891.35,1173.33 1920,1201.99 1920,1237.33 L1920,1856 C1920,1891.35 1891.35,1920 1856,1920 L64,1920 C28.6538,1920 0,1891.35 0,1856 L0,1237.33 C0,1201.99 28.6538,1173.33 64,1173.33 L106.667,1173.33 L106.667,661.333 C106.667,620.096 140.096,586.667 181.333,586.667 L533.333,586.667 Z M172.378,1280 L106.667,1280 L106.667,1813.33 L1813.33,1813.33 L1813.33,1280 L1747.62,1280 L1514.02,1493.33 L405.978,1493.33 L172.378,1280 Z M1013.33,0 L1013.33,1044.579 L1242.29,815.621 L1317.71,891.046 L960,1248.76 L602.288,891.046 L677.712,815.621 L906.667,1044.576 L906.667,0 L1013.33,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconArchiveLine = /*#__PURE__*/function (_Component) {
  _inherits(IconArchiveLine, _Component);

  var _super = _createSuper(IconArchiveLine);

  function IconArchiveLine() {
    _classCallCheck(this, IconArchiveLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconArchiveLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconArchive",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconArchiveLine.displayName = "IconArchiveLine";
  return IconArchiveLine;
}(Component);

IconArchiveLine.glyphName = 'archive';
IconArchiveLine.variant = 'Line';
IconArchiveLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconArchiveLine;
export { IconArchiveLine };